import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M21.271 8.25h5.459v5.459h-5.459zm0 26.041h5.459v5.459h-5.459zm0-13.02h5.459v5.459h-5.459z" }) }) })
});
export default SvgMore;
